export default "__VITE_ASSET__UzFDhYaq__"